import type { TrialConversionResponse } from '~entities/dashboard/api/get-trial-conversion';

export function formatTrialConversionRate(
  metrics?: Pick<TrialConversionResponse, 'conversionRate'> | null,
): string {
  return `${metrics?.conversionRate ?? 0}%`;
}

export function formatTrialConversionDetail(
  metrics?: Pick<
    TrialConversionResponse,
    'conversionRate' | 'convertedFamilies' | 'totalFamilies'
  > | null,
): string {
  return `${formatTrialConversionRate(metrics)} (${metrics?.convertedFamilies ?? 0} of ${metrics?.totalFamilies ?? 0} families)`;
}
